import { ServiceTerms } from './types';

const filterTerms = (terms: ServiceTerms[]) => {
  if (terms) return terms.filter((term: ServiceTerms) => !term.accepted);

  return [];
};

export default filterTerms;
